import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Segment, Tab } from 'semantic-ui-react'

import { getPageMHCArticlesFullList, getPageMHCYoutubeVideosFullList, } from '../../actions';
import HealthVideoList from '../../component/healtharticles/health_video_list';
import HealthArticlesList from '../../component/healtharticles/health_articles_list';

class HealthArticlesPage extends Component {
    componentDidMount() {
        const {accessToken} = this.props.user;
        this.props.getPageMHCArticlesFullList(accessToken);
        this.props.getPageMHCYoutubeVideosFullList(accessToken);
    }

    componentDidUpdate(prevProps) {
        const {contactNoVerified} = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            const {accessToken} = this.props.user;
            this.props.getPageMHCArticlesFullList(accessToken);
            this.props.getPageMHCYoutubeVideosFullList(accessToken);
        }
    }
    render() {
        console.log('HealthArticlesPage', this.props);
        const panes = [
            {
                menuItem: 'Articles',
                render: () => <Tab.Pane>
                                  <HealthArticlesList articles={ this.props.articleFullList } />
                              </Tab.Pane>
            },
            {
                menuItem: 'Videos',
                render: () => <Tab.Pane>
                                  <HealthVideoList videos={ this.props.articleVideoFullList } />
                              </Tab.Pane>
            },
        ]
        return (
            <Tab panes={ panes } />
            );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        articleFullList: state.appConfig.articleFullList,
        articleVideoFullList: state.appConfig.articleVideoFullList,
        contactNoVerified: state.otp.contactNoVerified,
    }
}

export default connect(mapStateToProps, {
    getPageMHCArticlesFullList,
    getPageMHCYoutubeVideosFullList
})(HealthArticlesPage);